<div class="alert alert-warning" *ngIf="empresa.cardapio?.modoVisualizacao">
    <i class="k-icon k-i-warning"></i> Cardápio configurado para <b>modo visualização</b>
</div>

<span [hidden]="empresa.sempreReceberPedidos">
  <div class="form-group mb-3 col-12">
    <label class="form-label fw-bold mb-2">Horários de Funcionamento do Serviço</label>

    <!-- Seletor de Serviço com Botões Toggle -->
    <div class="servico-selector">
      <div class="servico-buttons">
        <button
          type="button"
          class="btn servico-btn"
          *ngFor="let serv of servicos"
          [class.active]="servico.id === serv.id"
          (click)="selecionouServico(serv)"
          [title]="serv.descricao">
          <div class="servico-icon">
            <i class="fa" [class.fa-truck]="serv.id === 'site'"
               [class.fa-shopping-bag]="serv.id === 'siteretirada'"
               [class.fa-building]="serv.id === 'presencial'"></i>
          </div>
          <div class="servico-info">
            <div class="servico-tipo">{{ serv.label }}</div>
            <div class="servico-descricao">{{ serv.descricao }}</div>
          </div>
          <div class="servico-status" *ngIf="servico.id === serv.id">
            <i class="fa fa-check"></i>
          </div>
        </button>
      </div>
    </div>
  </div>

  <!-- Mensagem para serviços não obrigatórios sem horários -->
  <div class="alert alert-info mb-3" *ngIf="!ehServicoObrigatorio(servico.id) && !temHorariosCadastrados()">
    <div class="d-flex align-items-start">
      <i class="fa fa-info-circle mt-1 me-2"></i>
      <div>
        <h6 class="alert-heading">Usando Horários do Delivery</h6>
        <p class="mb-2">
          Este serviço não possui horários específicos configurados.
          O sistema está usando automaticamente os horários configurados no <strong>Delivery</strong>.
        </p>
        <button
          type="button"
          class="btn btn-sm btn-blue"
          (click)="abrirModalAdicionarHorario()">
          <i class="fa fa-plus"></i> Configurar Horários Específicos
        </button>
      </div>
    </div>
  </div>

  <!-- Calendário de Horários (apenas para serviços obrigatórios ou com horários configurados) -->
  <div class="form-group mb-2 col-12" *ngIf="ehServicoObrigatorio(servico.id) || temHorariosCadastrados()">
    <!-- Calendário Semanal -->
    <div class="calendario-semanal">
      <div class="calendario-header">
        <div class="dia-header"
             *ngFor="let dia of diasDaSemana"
             (click)="abrirModalSemana(dia.dia)"
             [class.com-horarios]="getHorariosDoDia(dia.dia).length > 0"
             [class.sem-horarios-header]="getHorariosDoDia(dia.dia).length === 0"
             [class.hoje]="ehHoje(dia.dia)"
             title="Clique para ver todos os horários da semana">
          <div class="dia-nome">{{ dia.abreviacao }}</div>
          <div class="dia-descricao">{{ dia.descricao }}</div>
          <div class="hoje-badge" *ngIf="ehHoje(dia.dia)">
            <span class="badge badge-warning">Hoje</span>
          </div>
        </div>
      </div>

      <div class="calendario-body">
        <div class="dia-coluna"
             *ngFor="let dia of diasDaSemana"
             [class.com-horarios]="getHorariosDoDia(dia.dia).length > 0"
             [class.sem-horarios-coluna]="getHorariosDoDia(dia.dia).length === 0"
             [class.hoje-coluna]="ehHoje(dia.dia)"
             [attr.data-dia-nome]="dia.abreviacao"
             [attr.data-dia-descricao]="dia.descricao">
          <div class="horarios-container">
            <div class="horario-item"
                 *ngFor="let horario of getHorariosDoDia(dia.dia)"
                 (click)="abrirModalEditarHorario(dia.dia, horario)"
                 title="Clique para editar">
              <div class="horario-info">
                <div class="horario-texto">
                  {{ formatarHorario(horario.horarioAbertura) }} - {{ formatarHorario(horario.horarioFechamento) }}
                </div>
                <div class="totalHorasTurno">
                  {{ obtenhaTempoAberto(horario) }}
                </div>
              </div>
            </div>

            <div class="sem-horarios"
                 *ngIf="getHorariosDoDia(dia.dia).length === 0"
                 (click)="abrirModalAdicionarHorario(dia.dia)"
                 title="Clique para adicionar horário">
              <div class="sem-horarios-texto">
                <i class="fa fa-clock-o"></i>
                <span>Loja fechada</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Botões de Ação -->
    <div class="mt-3 d-flex justify-content-between acoes-botoes">
      <button
        type="button"
        class="btn btn-primary"
        (click)="abrirModalAdicionarHorario()">
        <i class="fa fa-plus"></i> Adicionar Horário
      </button>

      <button
        type="button"
        class="btn btn-danger"
        (click)="removerTodosHorarios()"
        *ngIf="temHorariosCadastrados()">
        <i class="fa fa-trash"></i> Remover Todos os Horários
      </button>
    </div>
  </div>
</span>

<!-- Turnos Fixos 24h - Visível quando sempreReceberPedidos estiver marcado -->
<div class="form-group mb-4 col-12" *ngIf="empresa.sempreReceberPedidos">
  <div class="alert alert-info mb-3">
    <i class="fa fa-info-circle"></i>
    <strong>Modo 24 Horas Ativo</strong> - A loja receberá pedidos 24hs por dia, todos os dias da semana
  </div>

  <!-- Calendário com Turnos Fixos 24h -->
  <div class="calendario-semanal turnos-24h">
    <div class="calendario-header">
      <div class="dia-header turno-24h-header"
           *ngFor="let dia of diasDaSemana"
           [class.hoje]="ehHoje(dia.dia)">
        <div class="dia-nome">{{ dia.abreviacao }}</div>
        <div class="dia-descricao">{{ dia.descricao }}</div>
        <div class="hoje-badge" *ngIf="ehHoje(dia.dia)">
          <span class="badge badge-warning">Hoje</span>
        </div>
      </div>
    </div>

    <div class="calendario-body">
      <div class="dia-coluna turno-24h-coluna"
           *ngFor="let dia of diasDaSemana"
           [class.hoje-coluna]="ehHoje(dia.dia)"
           [attr.data-dia-nome]="dia.abreviacao"
           [attr.data-dia-descricao]="dia.descricao">
        <div class="horarios-container">
          <div class="horario-item turno-24h-item">
            <div class="horario-info">
              <div class="horario-texto">
                <i class="fa fa-clock-o"></i>
                00:00 - 23:59
              </div>
              <div class="turno-24h-label">
                <span class="badge badge-success">24h</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="form-group mb-4 col-12">
  <div class="input-group mt-2 mb-2">
    <input
      name="sempreReceberPedidos"
      id="sempreReceberPedidos"
      kendoCheckBox
      (change)="alterouSempreReceberPedidos()"
      class="k-checkbox ng-untouched ng-pristine ng-valid"
      type="checkbox"
      [(ngModel)]="empresa.sempreReceberPedidos"/>
    <label class="k-checkbox-label">Sempre receber pedidos</label>
  </div>


</div>
